import { createContext } from 'react';

import type { AuthStrategyContextValue } from './types';

export const AuthStrategyContext = createContext<AuthStrategyContextValue | null>(null);
